import { defineAsyncComponent } from "vue";
import { createColumnInput } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { callTitle } from "../../../company/user-company/user-company.section";
import lodash from "lodash";
import {
    createFieldInput,
    createFieldInputNumber, createFieldInputPassword,
    createFieldSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import { conditionFormChecker } from "../../../../../utils/form";
import store from "../../../../../store";

const CardBorder = defineAsyncComponent(() => import("../../../../../components/card/CardBorder"));
const TemplateBuilder = defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder"));
const UserCompanyChildrenList = defineAsyncComponent(() => import('./UserCompanyChildrenList'))

export const roleInfo  = () =>  {
    return store.state.resource.auth.info?.roles.filter(items => {
        return items.refRole?.name != "COMPANY_PARENT"
    }).map(items => ({ refRole: items.refRole }))
}

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.user.fullName"), dataIndex: "fullName" }),
        createColumnInput({
            title: () => i18n.global.t("model.user.username"), dataIndex: "username",
            search: {
                visible: () => false
            }
        })
    ];
    return columns;
};


export const createFieldUser = ({ props, data, key }) => {
    const { viewOnly } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return [
        createFieldInputNumber({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}idCard`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.idCard'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.idCard,
                'onUpdate:value': value => model.idCard = value,
                disabled: viewOnly,
                comma: false,
                onBlur: () => useForm.validate(field.key).catch(() => { }),
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldSelect({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}refTitle`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.lookup.modelGroup.TITLE'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.refTitle,
                'onUpdate:value': value => model.refTitle = value,
                disabled: viewOnly,
                list: callTitle,
                optKey: "key",
                optLabel: "value",
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
        }),
        createFieldInput({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}firstNameTh`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.firstNameTh'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.firstNameTh,
                'onUpdate:value': value => model.firstNameTh = value,
                disabled: viewOnly
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldInput({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}lastNameTh`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.lastNameTh'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.lastNameTh,
                'onUpdate:value': value => model.lastNameTh = value,
                disabled: viewOnly
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldInput({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}email`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.email'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.email,
                'onUpdate:value': value => model.email = value,
                disabled: viewOnly,
                onBlur: () => useForm.validate(field.key).catch(() => { }),
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldInputNumber({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}phone`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.phone'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.phone,
                'onUpdate:value': value => model.phone = value,
                disabled: viewOnly,
                comma: false
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldInputNumber({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}mobile`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.mobile'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.mobile,
                'onUpdate:value': value => model.mobile = value,
                disabled: viewOnly,
                comma: false
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldInput({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}fax`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.fax'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.fax,
                'onUpdate:value': value => model.fax = value,
                disabled: viewOnly,
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldInput({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}username`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.username'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.username,
                'onUpdate:value': value => model.username = value,
                disabled: viewOnly,
                onBlur: () => useForm.validate(field.key).catch(() => { }),
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldInputPassword({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}password`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.password'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.password,
                'onUpdate:value': value => model.password = value,
                disabled: viewOnly,
                onBlur: () => {
                    useForm.validate(field.key).catch(() => { })
                    useForm.validate(`${prefix}confirmPassword`).catch(() => { })
                },
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
        createFieldInputPassword({
            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
            key: `${prefix}confirmPassword`,
            colProp: () => ({ xs: 24, md: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('views.changePassword.confirmPassword'),
            inputProp: ({ field }) => (lodash.merge({
                value: model.confirmPassword,
                'onUpdate:value': value => model.confirmPassword = value,
                disabled: viewOnly,
                onBlur: () => {
                    useForm.validate(field.key).catch(() => { })
                    useForm.validate(`${prefix}password`).catch(() => { })
                },
            }, conditionFormChecker({ props, data, executeKey: 'inputPropField', params: { field } }))),
        }),
    ]
}


export const createFieldRole = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return [
        createFieldSelect({
            visible: ({ field }) => conditionFormChecker({
                props,
                data,
                executeKey: "visibleField",
                params: { field }
            }),
            key: `${prefix}userRoles`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t("model.role.modelName"),
            inputProp: ({ field }) => (lodash.merge({
                value: model.userRoles,
                "onUpdate:value": value => model.userRoles = value,
                disabled: viewOnly,
                list: roleInfo,
                renderLabel: ({ item }) => <span>{item.refRole.name} ({item.refRole.desc})</span>,
                optKey: "refRole.id",
                mode: "multiple",
            }, conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } }))),
            changeLog: { getValueChildren: ({ record }) => record.refRole?.name }
        }),
        {
            visible: () => conditionFormChecker({ props, data, executeKey: 'visibleSection', params: { sectionKey: 'UserCompanyChildren' } }),
            colProp: () => ({ xs: 24 }),
            formItemRender: () => {
                return <UserCompanyChildrenList
                        menuContext = { menuContext }
                        viewOnly = { viewOnly }
                        dataProp = { data }
                        itemsKey = "userCompanies"
                ></UserCompanyChildrenList>
            },
        },
    ];
};

export const createField = ({ props, data, key, isLoading }) => {
    data.section.user = createFieldUser({ props, data, key, isLoading });
    data.section.role = createFieldRole({ props, data, key, isLoading });
    return [
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <CardBorder title={i18n.global.t("views.company.register.user.title")}>
                <TemplateBuilder
                    rowProp={data.rowProp}
                    useForm={data.useForm}
                    fields={data.section.user}
                    skeleton={isLoading.value}
                ></TemplateBuilder>
            </CardBorder>
        },
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <CardBorder title={i18n.global.t('views.company.register.title')}>
                <TemplateBuilder
                    rowProp={data.rowProp}
                    useForm={data.useForm}
                    fields={data.section.role}
                    skeleton={isLoading.value}
                ></TemplateBuilder>
            </CardBorder>,
        },
    ];
};
